import { Navigate } from "react-router-dom";
import { firstFlexxiPath } from "../../config/navigation";
import { useAuth } from "../../stores/auth";

export function FlexxiIndexRedirect() {
  const { can, moduleEnabled } = useAuth();
  const path = firstFlexxiPath(can, moduleEnabled);
  if (!path) return <Navigate to="/" replace />;
  return <Navigate to={path} replace />;
}
